import { Switch, Tooltip, useMediaQuery, useTheme } from "@mui/material";
import { Accordion } from "@mui/material";
import { Box, Checkbox, IconButton, Typography } from "@mui/material";
import { CustomAccordionSummery } from "../../pages/Tracks/styles";
import { DateContainer } from "../../pages/Tracks/styles";
import { TrackDetailsContainerForAccordion } from "../../pages/Tracks/styles";
import { CustomTrackListTitle } from "../../pages/Tracks/styles";
import { styles, CustomActionsContainer } from "../../pages/Tracks/styles";
import { CustomVersionsCountContainer } from "../../pages/Tracks/styles";
import { CustomContributorsContainer } from "../../pages/Tracks/styles";
import { Collaborators } from "./Collaborators";
import { TrackMenu } from "./TrackMenu";
import {
  APP_BACKGROUND_COLOR,
  APP_COLOR,
  BORDER_COLOR,
  TEXT_COLOR,
} from "../../theme";
import { THEME } from "../../theme";
import { useContext, useEffect, useState } from "react";
import { TrackPlayPause } from "./TrackPlayPause";
import { TrackListViewProps } from "./types";
import { handleCreateGroupChat } from "../TrackComponents/TrackHandler/trackHandlers";
import {
  AuthContext,
  AuthContextInterface,
  UserDetailsContext,
} from "../../contexts";
import { TalkJsContext } from "../../contexts";
import { TalkJsContextInterface } from "../../contexts";
import { useLocation, useNavigate } from "react-router-dom";
import { KeyNote, TrackVersion, VersionState } from "../../proto/api_pb";
import { Collaborator, PostTrackResponse } from "../../proto/api_pb";
import { TrackState } from "../../proto/api_pb";
import { CollAndVersionContainer, TrackLeftSideContainer } from "./styles";
import { TrackNameAndCheckBoxContainer } from "./styles";
import { TrackNameAndStatusContainer } from "./styles";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { TrackObj } from "../../pages/MyTracks/types";
import { AccordionDetails } from "./AccordionDetails";
import { StatusAndNote } from "./StatusAndNote";
import { postTrack } from "../../services/trackService";
import { toast } from "react-toastify";
import useGetValidAccessToken from "../../hooks/useGetValidAccessToken";
import AddIcon from "@mui/icons-material/Add";
import { NotificationMenu } from "../Notification/NotificationMenu";
import MenuIcon from "@mui/icons-material/Menu";
import { ShareModal } from "../Modal/ShareModal";
const label = { inputProps: { "aria-label": "Checkbox demo" } };

export const TrackListView: React.FC<TrackListViewProps> = ({
  track,
  index,
  isBoxChecked,
  handleCheckedTrackChange,
  handleRefreshTracks,
  setIsPlayButtonClicked,
  trackToPlay,
  setTrackToPlay,
  setIsTrackForPlay,
  setVersionToPlay,
  setAudioDetails,
  handleOpenTrackVersionModal,
  handleOpenCollabsModal,
  handleOpenEditTrackModal,
  session,
  setInbox,
  handleExpandTrack,
  expanded,
  handleDragStart,
  handleDrop,
  setDraggedIndex,
  isReorderAvailable,
  handleOpenSelectDeleteModal,
  handleOpenUpdateSubModal,
  versionToPlay,
}) => {
  const talkJsContext = useContext<TalkJsContextInterface>(TalkJsContext);
  const [latestVersion, setLatestVersion] = useState<TrackVersion | undefined>(
    track.latestVersion
  );
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isVStateReadyForMastering, setIsVStateReadyForMastering] = useState(
    latestVersion?.getVersionState() ===
      VersionState.VERSION_STATE_READY_FOR_MASTERING
  );
  const { isEnterpriseAccount } = useContext(UserDetailsContext);
  const theme = useTheme();
  const isMediumOrSmall = useMediaQuery(theme.breakpoints.down("lg"));
  const isSmallerThanMedium = useMediaQuery(theme.breakpoints.up("md"));
  const [isExpanded, setIsExpanded] = useState(expanded);
  const { userId } = useContext<AuthContextInterface>(AuthContext);
  const { getValidAccessToken } = useGetValidAccessToken();
  const navigate = useNavigate();
  const location = useLocation();
  const { projectId } = location.state || {};
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const isTrackPublished =
    track.track?.getState() === TrackState.TRACK_STATE_PUBLISHED;
  const timestamp = track.track?.getModifiedTimestamp() ?? 0;
  const date = new Date(timestamp * 1000);
  const year = date.getFullYear();
  const mm = date.getMonth() + 1;
  const dd = date.getDate();

  const audioMetadata = latestVersion?.getAudioMetadata();
  const bpm = audioMetadata?.getBpm();
  const key = audioMetadata?.getKey();
  const keyString = key
    ? `${key.getKey()}${
        key.getNote() === KeyNote.KEY_NOTE_FLAT
          ? "♭"
          : key.getNote() === KeyNote.KEY_NOTE_SHARP
          ? "♯"
          : ""
      }`
    : "";

  const handlePlayButtonClick = () => {
    setIsPlayButtonClicked(true);
  };
  const createGroupChat = (
    id: string | undefined,
    title: string | undefined,
    contributors: Collaborator[] | undefined
  ) => {
    handleCreateGroupChat(
      talkJsContext,
      contributors,
      navigate,
      undefined,
      id,
      title
    );
  };

  const updateTrackPrivacy = async (track: TrackObj) => {
    try {
      if (track.track) {
        if (track.track.getState() === TrackState.TRACK_STATE_PUBLISHED) {
          track.track.setState(TrackState.TRACK_STATE_DRAFT);
        } else {
          track.track.setState(TrackState.TRACK_STATE_PUBLISHED);
        }
        const r = await postTrack(
          track.track,
          await getValidAccessToken(),
          userId
        );
        if (r instanceof PostTrackResponse) {
          if (track.track.getState() === TrackState.TRACK_STATE_PUBLISHED) {
            toast.info("Shared to explore page");
          } else {
            toast.info("Successfully update track privacy");
          }
          handleRefreshTracks();
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  function formatDuration(seconds: number) {
    if (!seconds || seconds <= 0) return "";
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${minutes}:${remainingSeconds.toString().padStart(2, "0")} mins`;
  }

  useEffect(() => {
    setIsExpanded(expanded);
  }, [expanded]);

  const handleToggle = () => {
    const newExpandedState = !isExpanded;
    setIsExpanded(newExpandedState);
    handleExpandTrack(track.track?.getId() ?? "");
  };

  return (
    <>
      <Accordion expanded={expanded} sx={styles.accordion}>
        <CustomAccordionSummery
          onDragLeave={(e) => setDraggedIndex(index)}
          draggable={isReorderAvailable}
          onDragStart={() => handleDragStart(index)}
          onDragEnd={(e) => handleDrop(e, index)}
          sx={{
            backgroundColor:
              isEnterpriseAccount && projectId
                ? "#10222e"
                : isEnterpriseAccount
                ? ""
                : APP_BACKGROUND_COLOR,
            background:
              isEnterpriseAccount && !projectId
                ? "linear-gradient(109deg, #CC5433 -80.71%, rgba(204, 84, 51, 0.13) 36.11%, rgba(204, 84, 51, 0.00) 62.63%)"
                : "",
            border: isSmallScreen ? `1px solid ${BORDER_COLOR}` : "none",
          }}
        >
          <TrackDetailsContainerForAccordion
            sx={{
              borderBottom:
                !isSmallScreen && !expanded ? `1px solid ${BORDER_COLOR}` : "",
              backgroundColor: isEnterpriseAccount ? "" : APP_BACKGROUND_COLOR,
              border: "none",
            }}
          >
            <TrackLeftSideContainer>
              <TrackNameAndStatusContainer>
                <TrackNameAndCheckBoxContainer>
                  <Checkbox
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    checked={isBoxChecked(track)}
                    size="small"
                    {...label}
                    sx={styles.checkBox}
                    onChange={(e) => {
                      e.stopPropagation();
                      if (handleCheckedTrackChange && track.track) {
                        handleCheckedTrackChange(track, track.track?.getId());
                      }
                    }}
                  />
                  {isReorderAvailable && (
                    <IconButton sx={{ padding: 0, margin: 0 }}>
                      <MenuIcon sx={{ fontSize: "15px" }} />
                    </IconButton>
                  )}
                  <TrackPlayPause
                    track={track}
                    handlePlayButtonClick={handlePlayButtonClick}
                    setTrackToPlay={setTrackToPlay}
                    setIsTrackForPlay={setIsTrackForPlay}
                    trackToPlay={trackToPlay}
                    setVersionToPlay={setVersionToPlay}
                  />
                  <Box>
                    <Box sx={{ display: "flex" }}>
                      <CustomTrackListTitle title={track.track?.getTitle()}>
                        {track.track?.getTitle()
                          ? (() => {
                              const title = track.track.getTitle();
                              return title.length > 20
                                ? title.charAt(0).toUpperCase() +
                                    title.slice(1, 20) +
                                    "..."
                                : title.charAt(0).toUpperCase() +
                                    title.slice(1);
                            })()
                          : ""}
                      </CustomTrackListTitle>
                      {track.notifications &&
                        track.notifications?.length > 0 && (
                          <NotificationMenu track={track} />
                        )}
                    </Box>
                    <p style={styles.genreTag}>
                      {track.track?.getArtist()
                        ? track.track.getArtist().charAt(0).toUpperCase() +
                          track.track.getArtist().slice(1)
                        : ""}
                    </p>
                    {latestVersion && (
                      <p style={styles.genreTag}>
                        {latestVersion?.getLengthSeconds() > 0 &&
                          formatDuration(latestVersion.getLengthSeconds())}
                        {latestVersion?.getLengthSeconds() > 0 &&
                          bpm !== 0 &&
                          " | "}
                        {bpm !== 0 && `${bpm} BPM`}
                        {bpm !== 0 && keyString && " | "}
                        {keyString && keyString}
                      </p>
                    )}
                    <p style={styles.genreTag}>
                      {track.track?.getSongMetadata()?.getGenre() && (
                        <>
                          {track.track.getSongMetadata()?.getGenre()}
                          {track.track?.getMoodsList()?.length ? " | " : ""}
                        </>
                      )}
                      {track.track?.getMoodsList()?.length
                        ? track.track.getMoodsList()
                        : ""}
                    </p>
                  </Box>
                </TrackNameAndCheckBoxContainer>
                <Box
                  sx={{
                    ...styles.outerNoteContainer,
                    ...(isSmallScreen
                      ? { width: "180px" }
                      : { minWidth: "175px" }),
                  }}
                >
                  {latestVersion && (
                    <StatusAndNote
                      version={latestVersion}
                      setIsVStateReadyForMastering={
                        setIsVStateReadyForMastering
                      }
                      handleRefreshTracks={handleRefreshTracks}
                      track={track.track!}
                    />
                  )}
                </Box>
              </TrackNameAndStatusContainer>
              <DateContainer sx={{ marginLeft: "10px" }}>
                <Typography
                  sx={{ fontSize: "14px", color: TEXT_COLOR }}
                >{`${mm}/${dd}/${year}`}</Typography>
              </DateContainer>
              <CollAndVersionContainer>
                <CustomContributorsContainer>
                  {track.track && (
                    <Collaborators
                      collaborators={track.track.getCollaboratorsList() ?? []}
                      isGridView={false}
                    />
                  )}
                </CustomContributorsContainer>
                <CustomVersionsCountContainer sx={{ fontSize: "14px" }}>
                  v{" "}
                  {latestVersion?.getVersionNumber()
                    ? /^\d$/.test(`${latestVersion.getVersionNumber()}`)
                      ? latestVersion.getVersionNumber() + ".0"
                      : latestVersion.getVersionNumber()
                    : ""}
                  <IconButton
                    sx={{ padding: 0.3, margin: 0 }}
                    onClick={handleToggle}
                  >
                    {isExpanded ? (
                      <KeyboardArrowUpIcon
                        fontSize="small"
                        sx={{ color: APP_COLOR }}
                      />
                    ) : (
                      <KeyboardArrowDownIcon
                        fontSize="small"
                        sx={{ color: APP_COLOR }}
                      />
                    )}
                  </IconButton>
                  <Tooltip placement="top" title="Add Version">
                    <IconButton
                      sx={{ padding: 0.3, margin: 0 }}
                      onClick={() => {
                        if (track?.latestVersion?.getVersionNumber())
                          handleOpenTrackVersionModal(
                            track.track!,
                            track?.latestVersion?.getVersionNumber()
                          );
                      }}
                    >
                      <AddIcon
                        sx={{ filter: "contrast(30%)", fontSize: "20px" }}
                      />
                    </IconButton>
                  </Tooltip>
                </CustomVersionsCountContainer>
              </CollAndVersionContainer>
            </TrackLeftSideContainer>
            {isSmallerThanMedium && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Tooltip
                  placement="top"
                  title={
                    !isTrackPublished ? "Share to Explore Page" : "Make Private"
                  }
                >
                  <span style={{ fontSize: "12px" }}>
                    <IconButton
                      disableRipple
                      onClickCapture={(e) => {
                        e.stopPropagation();
                        updateTrackPrivacy(track);
                      }}
                      sx={{ color: "white", zIndex: 999, marginLeft: -1 }}
                    >
                      <Switch
                        sx={{
                          "& .MuiSwitch-switchBase": {
                            padding: 1,
                            "&.Mui-checked": {
                              transform: "translateX(12px)",
                              "& + .MuiSwitch-track": {
                                opacity: 1,
                                backgroundColor: isTrackPublished
                                  ? "#2EBDE5"
                                  : "#BDBDBD",
                              },
                            },
                          },
                          "& .MuiSwitch-thumb": {
                            width: 12,
                            height: 14,
                            backgroundColor: isTrackPublished
                              ? "white"
                              : "#BDBDBD",
                          },
                          "& .MuiSwitch-track": {
                            borderRadius: 20 / 2,
                            width: 28,
                            height: 16,
                            opacity: 1,
                            backgroundColor: isTrackPublished
                              ? "#2EBDE5"
                              : "#3E4043",
                          },
                        }}
                        size="small"
                        checked={isTrackPublished}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    </IconButton>
                  </span>
                </Tooltip>
              </Box>
            )}
            <CustomActionsContainer>
              {!isSmallerThanMedium && (
                <Box>
                  <Tooltip
                    placement="top"
                    title={
                      !isTrackPublished
                        ? "Share to Explore Page"
                        : "Make Private"
                    }
                  >
                    <span style={{ fontSize: "12px" }}>
                      <IconButton
                        disableRipple
                        onClickCapture={(e) => {
                          e.stopPropagation();
                          updateTrackPrivacy(track);
                        }}
                        sx={{ color: "white", zIndex: 999, marginLeft: -1 }}
                      >
                        <Switch
                          sx={{
                            "& .MuiSwitch-switchBase": {
                              padding: 1,
                              "&.Mui-checked": {
                                transform: "translateX(12px)",
                                "& + .MuiSwitch-track": {
                                  opacity: 1,
                                  backgroundColor: isTrackPublished
                                    ? "#2EBDE5"
                                    : "#BDBDBD",
                                },
                              },
                            },
                            "& .MuiSwitch-thumb": {
                              width: 12,
                              height: 14,
                              backgroundColor: isTrackPublished
                                ? "white"
                                : "#BDBDBD",
                            },
                            "& .MuiSwitch-track": {
                              borderRadius: 20 / 2,
                              width: 28,
                              height: 16,
                              opacity: 1,
                              backgroundColor: isTrackPublished
                                ? "#2EBDE5"
                                : "#3E4043",
                            },
                          }}
                          size="small"
                          checked={isTrackPublished}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      </IconButton>
                    </span>
                  </Tooltip>
                </Box>
              )}
              <Box
                sx={
                  isMediumOrSmall
                    ? {
                        width: "80%",
                        display: "flex",
                        justifyContent: "space-between",
                      }
                    : {}
                }
              >
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    if (session) {
                      const talkInbox = session.createInbox();
                      setInbox(talkInbox);
                      talkJsContext.setIsChatOpen(true);
                      const trackId = track.track?.getId();
                      const trackTitle = track.track?.getTitle();
                      const contributors = track.track?.getCollaboratorsList();
                      if (trackId && trackTitle) {
                        createGroupChat(trackId, trackTitle, contributors);
                      }
                      if (isSmallScreen) navigate("/messages");
                    }
                  }}
                >
                  <Tooltip placement="top" title="Chat with the artists">
                    <img
                      style={{
                        filter:
                          THEME === "light" ? "invert(100%)" : "invert(0%)",
                        width: "17px",
                        height: "17px",
                      }}
                      src="/assets/icons/TracksPageIcons/message-chat-circle.svg"
                      alt="icon"
                    />
                  </Tooltip>
                </IconButton>
                <ShareModal
                  id={track.track?.getId() ?? ""}
                  isTrack={true}
                  title={track.track?.getTitle() ?? ""}
                />
                <TrackMenu
                  track={track}
                  handleOpenCollabsModal={handleOpenCollabsModal}
                  handleOpenEditTrackModal={handleOpenEditTrackModal}
                  handleOpenSelectDeleteModal={handleOpenSelectDeleteModal}
                  handleRefreshTracks={handleRefreshTracks}
                  handleOpenUpdateSubModal={handleOpenUpdateSubModal}
                />
              </Box>
            </CustomActionsContainer>
          </TrackDetailsContainerForAccordion>
        </CustomAccordionSummery>
        <AccordionDetails
          handleOpenTrackVersionModal={handleOpenTrackVersionModal}
          track={track}
          handlePlayButtonClick={handlePlayButtonClick}
          setVersionToPlay={setVersionToPlay}
          setIsTrackForPlay={setIsTrackForPlay}
          setAudioDetails={setAudioDetails}
          setLatestVersion={setLatestVersion}
          expanded={expanded}
          handleRefreshTracks={handleRefreshTracks}
          versionToPlay={versionToPlay}
          setTrackToPlay={setTrackToPlay}
        />
      </Accordion>
    </>
  );
};
